var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAvalanche(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 13,
    viewBox: "0 0 14 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.428 7.62702C10.7481 7.04508 11.2647 7.04508 11.5849 7.62702L13.5786 11.3101C13.8988 11.892 13.6368 12.3668 12.9965 12.3668H8.97998C8.34694 12.3668 8.08499 11.892 8.39788 11.3101L10.428 7.62702ZM6.57152 0.536552C6.89168 -0.0453872 7.40102 -0.0453872 7.72118 0.536552L8.16503 1.37883L9.21282 3.31608C9.4675 3.86739 9.4675 4.51824 9.21282 5.06955L5.69836 11.4785C5.3782 11.9992 4.84703 12.3285 4.25765 12.3668H1.33984C0.699525 12.3668 0.437577 11.8997 0.757735 11.3101L6.57152 0.536552Z",
    fill: "#564A27"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvalanche);
export default __webpack_public_path__ + "static/media/avalanche.0651bade.svg";
export { ForwardRef as ReactComponent };